export const handleErrorMessage = (
  error: unknown,
  defaultMessage: string
): string | string[] => {
  const extractMessage = (err: unknown): string => {
    if (typeof err === 'string') {
      return err;
    }
    if (
      err &&
      typeof err === 'object' &&
      ('message' in err || 'base' in err || 'error_message' in err)
    ) {
      return (
        (err as any).message ||
        (err as any).error_message ||
        (err as any).base ||
        defaultMessage
      );
    }
    return defaultMessage;
  };

  if (Array.isArray(error)) {
    return error.map(extractMessage);
  }

  return extractMessage(error);
};
